export default function ContactoTI() {
  return (
    <div className="mt-3 mb-3 d-flex justify-content-center px-3">
      <div className="contact-card d-flex align-items-center flex-wrap gap-2 rounded-3 border bg-light-subtle px-3 py-2">
        <i className="pi pi-envelope flex-shrink-0" aria-hidden="true" />
        <span className="small text-muted">
          Para solicitar nuevas funcionalidades o reportar errores, escribe a
        </span>
        <a
          href="mailto:camila.mendoza@transkyrios.com"
          className="small fw-semibold link-primary text-decoration-none text-break"
        >
          camila.mendoza@transkyrios.com
        </a>
      </div>
    </div>
  )
}